export default __webpack_public_path__ + "static/media/preloader.a6525050.gif";